import instance from "@/services/api";

export const financePaymentCreateForMasterAPI = {
  async read(params) {
    return await instance()
      .get("/finance_payment/create-for-master/read/", { params })
      .then((res) => res?.data);
  },
  async create(payload) {
    return await instance()
      .post("/finance_payment/create-for-master/create/", payload)
      .then((res) => res?.data);
  },
  async report(payload) {
    return await instance()
      .post("/finance_payment/create-for-master/report/", payload)
      .then((res) => res?.data);
  },
  async reportDetail(financePaymentId) {
    return await instance()
      .get(`/finance_payment/create-for-master/report/${financePaymentId}/`)
      .then((res) => res?.data);
  },
  async sendToBi() {
    return await instance()
      .get("/project/cron/payment/send/")
      .then((res) => res?.data);
  },
};

